import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { loadable } from 'jotai/utils';

export const useUserTDK = (): { title: string; description: string; keywords: string } => {
  const { t } = useTranslation();
  const loadableUser = useAtomValue(loadable($CurrentAvailableUserOrNull));

  if (loadableUser.state !== 'hasData' || !loadableUser.data) {
    return {
      title: '',
      description: '',
      keywords: '',
    };
  }

  const user = loadableUser.data;

  const description = t('user_helmet_description_1')
    .replace('%1$s', user.nickName || '')
    .replace('%2$s', user.description || '');

  const title = `${t('user_helmet_title')
    .replace('%1$s', (user && user.nickName) || '')
    .replace('%2$s', t('contribute'))}|Lemon8`;

  const keywords = t('keyword_default');

  return {
    title,
    description,
    keywords,
  };
};
